import { useCallback, useEffect, useState } from 'react';
import { readAfasDebugMode, writeAfasDebugMode } from '../utils/afasDebugMode';

/**
 * Session-scoped AFAS debug mode for a community (Beheerder toggle / Synchronisatie column).
 */
export const useAfasDebugMode = (communityId) => {
    const [debugMode, setDebugMode] = useState(() => readAfasDebugMode(communityId));

    useEffect(() => {
        setDebugMode(readAfasDebugMode(communityId));
    }, [communityId]);

    useEffect(() => {
        if (!communityId || typeof window === 'undefined') {
            return undefined;
        }

        const onStorage = (event) => {
            if (event.key !== `afas-koppeling-debug-mode:${communityId}`) {
                return;
            }
            setDebugMode(event.newValue === '1');
        };

        window.addEventListener('storage', onStorage);
        return () => window.removeEventListener('storage', onStorage);
    }, [communityId]);

    const setEnabled = useCallback(
        (enabled) => {
            const next = Boolean(enabled);
            setDebugMode(next);
            writeAfasDebugMode(communityId, next);
        },
        [communityId],
    );

    return [debugMode, setEnabled];
};

export default useAfasDebugMode;
